import { AbstractControl, ValidatorFn } from '@angular/forms';

export function RequireMatch(propertyName: string): ValidatorFn {
  return (control: AbstractControl) => {
    const selection: any = control.value;

    if (selection && this[propertyName] && this[propertyName].indexOf(selection) < 0) {
      return { incorrect: true };
    }

    return null;
  };
}
